exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.input-group {\n  display: block;\n  clear: both;\n}\ndiv.input-group .input-group-btn {\n  float: left;\n  margin-right: 2px;\n}\ndiv.input-group .input-group-btn button.iconButton i {\n  font-size: 14pt;\n}\ndiv.input-group input[type=number]::-webkit-inner-spin-button,\ndiv.input-group input[type=number]::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\ndiv.input-group input[type=number] {\n  -moz-appearance: textfield;\n  text-align: center;\n  float: left;\n  min-width: 40px;\n  font-size: 16pt;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/artur/workspace/vscode/warpriders/src/app/content/contact/number-picker/number-picker.component.less
// module id = ../../../../../src/app/content/contact/number-picker/number-picker.component.less
// module chunks = 1